import React from 'react'

import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'

const NoMatchPage = ({ match, history, location, intl }) => {
  return (
    <div className='frontend-wrapper-xl'>
      <div className='noMatchPageContainer'>
        <div style={{ display: 'block' }}>
          <div className='noMatchPage' />
          <h2>{intl.formatMessage({ id: 'Load.Common.PageNotFoundPubb' })}</h2>
          <p>{intl.formatMessage({ id: 'Load.Common.PageNotFoundPubbDescr' })}</p>

        </div>
      </div>
    </div>
  )
}

export default injectIntl(withRouter(NoMatchPage))
